import React from "react";
import CountryFlag from "./CountryFlag";
import { currentLanguage, t } from "../i18n";
import "./ProfileMeta.css";

// The small line under a name (founder, 2026-11-03): the flag, the country and
// when they joined. Either half can be missing; with neither, no line at all.

/** A country's name in the app's language, from the phone's own list. */
export function countryName(code?: string | null): string {
  if (!code) return "";
  try {
    return new Intl.DisplayNames([currentLanguage()], { type: "region" }).of(code.toUpperCase()) || code;
  } catch {
    return code;
  }
}

const joinedDate = (at?: string | null): string => {
  const d = at ? new Date(at) : null;
  if (!d || Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(currentLanguage(), { month: "short", year: "numeric", timeZone: "UTC" });
};

const ProfileMeta: React.FC<{ countryCode?: string | null; joinedAt?: string | null }> = ({ countryCode, joinedAt }) => {
  const joined = joinedDate(joinedAt);
  if (!countryCode && !joined) return null;
  return (
    <div className="pmeta">
      {countryCode && (
        <span className="pmeta-country">
          <CountryFlag code={countryCode} />
          {countryName(countryCode)}
        </span>
      )}
      {countryCode && joined && <span aria-hidden="true">·</span>}
      {joined && <span>{t("profileMeta.joined", { date: joined })}</span>}
    </div>
  );
};

export default ProfileMeta;
